<template>
  <div id="" class="" v-if="internalAssessment">
    <div class="" v-if="internalAssessment.judges">



    <div class="preStep"  v-if="step == 0">

    <div class="row welcome" style="height:100vh">
      <div class="col-0 col-lg-6 hideOnResponsive" style="padding:0;margin:0;">
        <img :src="require('@/assets/backgroundJudgePreStep.jpeg')" style="height:100%;width:100%;object-fit:cover;" alt=""/>

      </div>
      <div class="col-12 col-lg-6" style="background: transparent linear-gradient(105deg, #1D2091 0%, #3783C5 49%, #3783C5 100%) 0% 0% no-repeat padding-box;display:flex;
      justify-content:center;align-items:center;position:relative;padding-top:50px;padding-bottom:50px;">
      <img :src="require('@/assets/ruban.png')" class="hideOnResponsive" style="position:absolute;bottom:0;left:-50%;z-index:0;" alt=""/>

        <div class="inner innerWelcome"  v-if="nameForInit == ''">
          <div class="" style="text-align:center;margin-bottom:20px;" id="logoCorpo" v-if="internalAssessment.user">
               <img style="margin:auto;width:200px;"  :src="this.apiUrl+'/get_image/'+internalAssessment.user.logo.$oid+'?token='+$store.state.innotoken" alt="" v-if="internalAssessment.user.logo">
               <img style="margin:auto;width:200px;" src="https://www.innopearl.ch/wp-content/uploads/2024/06/logoInnopearl.svg" alt="" v-else>
          </div>
          <div class="welcomeMessage" style="font-size:30px;font-weight:700;margin-bottom:50px;text-align:center;">
              {{$t('Welcome to')}} {{internalAssessment.name}}
          </div>
          <div class="pleaseConfim"  style="font-size:20px;font-weight:500;margin-bottom:50px;text-align:center;">
            {{$t('Please confirm your name and position to start your assessment')}}
          </div>
          <div class="inputFieldName" style="display:flex;align-items:center;justify-content:center;margin-bottom:25px;">
            <input type="text"  :placeholder="$t('Type your name')" maxLength="30" class="innopearl_input" v-model="internalAssessment.judges.name">

          </div>
          <div class="inputFieldPosition" style="display:flex;align-items:center;justify-content:center;margin-bottom:25px;">
            <!-- <input type="text"  :placeholder="$t('Type your name')" maxLength="30" class="innopearl_input" v-model="internalAssessment.judges.position"> -->
            <!-- <select  v-model="internalAssessment.judges.position" class="position-select" placeholder="Select your position">
              <option value="">{{$t("Sort by...")}}</option>
              <option value="nameASC">{{$t("Name ASC")}}</option>
              <option value="nameDESC">{{$t("Name DESC")}}</option>
              <option value="statusASC">{{$t("Status ASC")}}</option>
              <option value="statusDESC">{{$t("Status DESC")}}</option>
              <option value="deadlineASC">{{$t("Deadline ASC")}}</option>
              <option value="deadlineDESC">{{$t("Deadline DESC")}}</option>
            </select> -->
            <v-select class="inputFieldPositionSelect" v-model="internalAssessment.judges.position" :items="function_in_possibles" item-title="name" item-value="name" :label="$t('Please select your function')" ></v-select>

          </div>
          <div class="confirmName">
            <button type="button" style="width:100%;padding:20px 10px;font-size:20px;font-weight:700; background:#115AA4;color:#FFF;border-radius:50px;" name="button" @click="confirmJudgeName()" :disabled="internalAssessment.judges.name == '' || !internalAssessment.judges.position">{{$t('Start assessment')}}</button>
          </div>
        </div>
        <div  class="inner innerWelcome"  v-else>
          <div class="" style="text-align:center;margin-bottom:20px;" id="logoCorpo" v-if="internalAssessment.user">
               <img style="margin:auto;width:200px;"  :src="this.apiUrl+'/get_image/'+internalAssessment.user.logo.$oid+'?token='+$store.state.innotoken" alt="" v-if="internalAssessment.user.logo">
               <img style="margin:auto;width:200px;" src="https://www.innopearl.ch/wp-content/uploads/2024/06/logoInnopearl.svg" alt="" v-else>
          </div>
          <div class="welcomeMessage" style="font-size:30px;font-weight:700;margin-bottom:50px;text-align:center;">
              {{$t('Welcome back to')}} {{internalAssessment.name}}
          </div>

          <div class="confirmName">
            <button type="button" style="width:100%;padding:20px 10px;font-size:20px;font-weight:700; background:#115AA4;color:#FFF;border-radius:50px;" name="button" @click="step = 1;">{{$t('Continue assessment')}}</button>
          </div>
        </div>

      </div>
    </div>
    </div>

    <div class="realContentAssessment" v-else>

      <div class="container-fluid main_container" >
        <div class="row">
          <div class="d-none-xs d-none-sm col-md-1 col-xl-2 col sidebarCol" id="mainsidebar">
            <SidebarJudge/>

          </div>

          <div class="col-12 col-md-11 col-xl-10 col" id="mainContent">
                    <TopBar />
                    <div class="p-rl-20" v-if="internalAssessment.status == 'completed' && !seeMyAssessment">
                      <div class="internalAssessment_inner tcenter">
                        <div class="thank_you_container">
                          <div class="thank_you">
                            <div class="titre_1">
                              Thank you for your engagement.
                            </div>
                            <div class="image_1">
                              <img :src="require('@/assets/thanyouimage.png')" alt="">
                            </div>
                            <div class="text_1 texte_1">
                              <p>Unfortunately, the deadline for this assessment has now passed. </p>
                              <p>We look forward to collaborating with you on future innovator assessments. </p>

                            </div>
                          </div>
                          <div class=" tcenter">
                            <button @click="seeMyAssessment = true" type="button" class="next_step_btn" style="display:inline-block;padding:10px 20px;font-size:20px;background:#115AA4;color:#FFF;border-radius:50px;"  name="button">{{$t("See my assessments")}}</button>

                          </div>
                        </div>

                      </div>

                    </div>
                    <div class="p-rl-20" v-else-if="getNotAssessedStartups().length == 0 && !seeMyAssessment">
                      <div class="internalAssessment_inner tcenter">
                        <div class="thank_you_container">
                          <div class="thank_you">
                            <div class="titre_1">
                              Thank you for completing the assessment.
                            </div>
                            <div class="text_1 texte_1">
                              You can still review and make modifications before the deadline.
                            </div>
                            <div class="image_1">
                              <img :src="require('@/assets/thanyouimage.png')" alt="">
                            </div>
                          </div>
                          <div class=" tcenter">
                            <button @click="seeMyAssessment = true" type="button" class="next_step_btn" style="display:inline-block;padding:10px 20px;font-size:20px;background:#115AA4;color:#FFF;border-radius:50px;"  name="button">{{$t("See my assessments")}}</button>

                          </div>
                        </div>

                      </div>

                    </div>
                    <!-- <div class="p-rl-20" v-if="internalAssessment.status == 'completed' && !seeMyAssessment">
                      <div class="internalAssessment_inner tcenter">
                        <div class="thank_you_container">
                          <div class="thank_you">
                            <div class="titre_1">
                               Thank you, <span v-if="internalAssessment.judges">{{internalAssessment.judges.name}}</span> for your collaboration on this assessment 
                            </div>
                            <div class="image_1">
                              <img :src="require('@/assets/thanyouimage.png')" alt="">
                            </div>
                            <div class=" tcenter">
                              <button @click="seeMyAssessment = true" type="button" class="next_step_btn" style="display:inline-block;padding:10px 20px;font-size:20px;background:#115AA4;color:#FFF;border-radius:50px;"  name="button">{{$t("See my assessments")}}</button>

                            </div>
                        </div>

                      </div>

                    </div>
                    </div> -->
              <JudgeViewSummary :internalAssessment="internalAssessment" :token="token" :votes="votes" v-if="seeMyAssessment"/>
            <div id="footer" >
                  <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo_extra_small" alt="">

                  <small class="footerAbs">Innopearl © {{new Date().getFullYear() }}</small>
            </div>
          </div>
        </div>
      </div>



    </div>
  </div>
        <div  v-else>

                <div class="thank_you_container tcenter">
                  <div class="thank_you">
                    <div class="titre_1">
                      Thank you for your engagement.
                    </div>
                    <div class="image_1">
                      <img :src="require('@/assets/thanyouimage.png')" alt="">
                    </div>
                    <div class="text_1 texte_1">
                      <p>Unfortunately, the deadline for this assessment has now passed. </p>
                      <p>We look forward to collaborating with you on future innovator assessments. </p>

                    </div>
                  </div>



          </div>
        </div>
  </div>
</template>
<script>
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css';
 import SidebarJudge from '@/components/sidebar/SidebarJudge.vue'
 import JudgeViewSummary from '@/components/JudgeViewSummary.vue'
import TopBar from '@/components/sidebar/TopBarJudge.vue';
//
// //import { Toaster, toast } from 'vue-sonner'
// import CreateCriteriaModal from '@/components/modals/createCriteria.vue'
// import CriteriaDetails from '@/components/CriteriaDetail.vue'
  import api from '../tools/api';
 import { toast } from 'vue-sonner'
export default {
  components: {
    SidebarJudge,
    TopBar,
    JudgeViewSummary
    // QuillEditor,
    // CreateCriteriaModal,
  //   CriteriaDetails,
  //  StartupInfoLine
  },
  name: 'InternalAssessmentPreview',
  data() {
    return {
      dialog:false,
      seeMyAssessment: true,
      function_in_possibles:[],
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Preview"),
      },
      votes:[],
      nameForInit : "",
      demoValue:[],
      demoDisable:[],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      showDetailsIndexInFav:null,
      step: 0,
      token:"",
      internalAssessment : {
        type:"",
        user:null,
        name : "",
        project : null,
        deadline : null,
        description : "",
        criterias : [],
        disableFeedback : false,
        feedback_1 : "",
        feedback_2 : "",
        feedback_3 : "",
        startups : [],
        judges : []
      },

    }
  },
  methods:{
    getGroupNameById(id) {
      console.log("search id:",id);
      console.log(this.criteriaGroups);
      var group = this.criteriaGroups.find(g => g._id.$oid == id.$oid);
      console.log("dinf ",group);
      return group ? group.name : null; // Return the groupname or null if not found
    },
    getNotAssessedStartups(){
      var votedStartupIds = new Set();
      if(this.votes){
         votedStartupIds = this.votes.length ? new Set(this.votes.map(vote => vote.startup._id.$oid)) : new Set(); // Handle empty votes array

      }


      var iii =  this.internalAssessment.startups.filter(startup =>
      !votedStartupIds.has(startup._id.$oid)
    );

    return iii;
  },
    toggleDetailsSelected(index) {

      if (this.showDetailsIndexInSelected === index) {
        this.showDetailsIndexInSelected = null; // Hide if already visible
      } else {
        this.showDetailsIndexInSelected = index; // Show the clicked index
        this.showDetailsIndexInFav = null; // Hide if already visible
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      }
    },
    hideDetails(){
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      this.showDetailsIndexInAvailable = null; // Hide if already visible

    },
    getAssessmentForJudge(step){
      this.token = this.$route.params.token;
      this.axios.get(process.env.VUE_APP_API_URL+"/judgeAssessment/"+this.$route.params.token+"/"+this.$route.params.id).then( (r) => {
        this.internalAssessment = r.data;
        // if(this.internalAssessment.status == 'completed')this.seeMyAssessment = false;
        // else this.seeMyAssessment = true;
        if(this.internalAssessment.deadline){
          this.deadlineDateFormated = this.internalAssessment.deadline.date.split(' ')[0];
        }
        this.nameForInit = this.internalAssessment.judges.name;
        this.internalAssessment.criterias.forEach((item,i) => {
          console.log(item);
          this.demoValue[i] = 3;
          this.demoDisable[i] = false;
        });
        this.step = step;

      }).catch( (e) => console.log(e));
    },
    getAssessmentVoteForJudge(){
      this.token = this.$route.params.token;
      this.axios.get(process.env.VUE_APP_API_URL+"/judgeVotes/"+this.$route.params.token+"/"+this.$route.params.id).then( (r) => {
        this.votes = r.data;
        if(this.internalAssessment.status == 'completed')this.seeMyAssessment = false;
        else {
            this.seeMyAssessment = true;
        }


      }).catch( (e) => {console.log(e);this.seeMyAssessment = true;});
    },
    transformDate(dateString) {
 const date = new Date(dateString);
 const day = String(date.getDate()).padStart(2, '0');
 const month = String(date.getMonth() + 1).padStart(2, '0');
 const year = date.getFullYear();
 return `${day}/${month}/${year}`;
},
    confirmJudgeName(){
      console.log(this.internalAssessment);
      this.axios.post(process.env.VUE_APP_API_URL+"/setJudgeName",
        {
          assessment :this.internalAssessment,
          token : this.$route.params.token,
        },
        { headers: {'Content-Type': 'application/json',}}
      ).then( (r) => {
          console.log("dfqsd",r.data);
          this.getAssessmentForJudge(1);
        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    }
},
  mounted(){

    if(this.$route.params.id != "undefined" && this.$route.params.token != "undefined"){
      if(this.$route.query.step){
          this.getAssessmentForJudge(this.$route.query.step);
      }
      else{
        this.getAssessmentForJudge(0);
      }

      this.getAssessmentVoteForJudge();
     }
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     api.get(process.env.VUE_APP_API_URL+"/dict/dict_userfunction").then( (r) => {
       console.log(r);
       this.function_in_possibles = r.data
     }).catch( (e) => {
     if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
     else toast.error("Sorry, an error occurred. Please try again. ")
     });
     // api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
     //   this.criteriaGroups = r.data;
     //   console.log("criterias : ",r.data);
     //   console.log(r);
     // }).catch( (e) => console.log(e));

  },
  computed:{

},
watch:{

}

}
</script>
<style media="screen" scoped>
.internalAssessment{

}
.internalAssessment_inner{
  margin-top:50px;
  margin-bottom: 50px;
    padding: 50px;
    padding-top:25px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.assessment-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fbfbfb;
        padding:20px;
}



.next-button {
    color: #fff;
    background: #3783C5 0% 0% no-repeat padding-box;
    padding: 14px 37px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        border-radius: 200px;
}

.status {
    display: flex;
    align-items: center;
    background-color: #f7e8c2;
    padding: 5px 15px;
    border-radius: 15px;
}

.status-text {
    color: #996600;
    font-size: 14px;

}


.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 10px;
  }

  .left {
    flex-wrap: wrap;
  }
}
.oneInfoAboutTitle{
  font-size:14px;
  font-weight:700;
  color:#000;
}
.mainColTitle{
  color:rgba(4, 36, 106, 1);
  font-size:20px;
  font-weight: 700;
}
.internalAssessmentContent2Col .criterias,
.internalAssessmentContent2Col .judges{
  padding:20px;
}
.internalAssessmentContent2Col .criterias{

  border:1px solid rgba(55, 131, 197, 1);
  border-radius:20px;
}
.criteriaList{
  display:flex;
  flex-direction: column;
  gap:20px;
  margin-top:20px;
}
.oneCriteria .criteriaHead{
  display:flex;
  gap:10px;
  position:relative;
}
.oneCriteria .criteriaHead .criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaHead .v-img{
  width:18px;
  flex:none;
}

.vsliderIndicator{
  font-size:15px;
  font-weight: 500;
  color:#000;
}

.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
}

.criteriaVoting{
  display:flex;
  gap:20px;
  align-items: center;
}
.criteriaVoting .myslider{
  width:70%;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:10px;
height: 40px;
padding: 5px;
width:100%;
}
.innopearl_input::placeholder{
  color:#888 !important;
  opacity:1;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .candidate_card_head{
    background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }
  .candidate_card_head .name{
    flex:1;
  }
  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }

  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid rgba(18, 90, 164, 1) !important;
    color: rgba(18, 90, 164, 0.2) !important;
  caret-color: rgba(18, 90, 164, 0.2) !important;
  backdrop-filter: blur(40px);

  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #FFF;
  color: #BBB;
  border: 1px solid #BBB;
  border-radius: 10px;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #E1E1E1 !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}

.listOfJudges{
  display:flex;
  gap:20px;
  margin-top:10px;
  flex-wrap: wrap;
}



.oneJudgeSelected{
  background:#480C831A;
  color:#480C83;
  padding:5px 20px;
  display:flex;
  gap:10px;
  border-radius: 200px;
  border: 1px solid #480C831A;
  position:relative;
}
.subTitleJudge{
  font-size:16px;
  font-weight: 700;
  color:#04246A;
  margin-bottom:10px;
  display:block;
  width:100%;
}

.judgesWithLicenses
{
    padding-top:35px;
padding-bottom:25px;
border-bottom: 1px solid #BACFE5;
}
.judgesWithoutLicences{
  padding-top:35px;
padding-bottom:25px;
border-bottom: 1px solid #BACFE5;
}

.oneInfoAboutValue p{
  padding:0;
  margin:0;
}

.innerWelcome{
  background:#FFF;max-width:750px;width:80%;
  padding:50px;border-radius:20px;z-index:20;
}
@media screen and (max-width:990px){
  .hideOnResponsive{
    display:none;
  }
  .innerWelcome{
    width:95%;
  }
}
#content{
  /* margin-left: 15%; */
  background : #EAEAEA;
  min-height: calc(100vh);
  padding-bottom: 50px;

}

.main_container > .row > .col{
  padding: 0px !important;
  margin: 0px !important;
}
.sidebarCol{
  min-height:100vh;position:relative;z-index:40;
      box-shadow: 0px 3px 6px #00000029;
}

.prev_step_btn,
.next_step_btn,
.contact_step_btn{
    display:inline-block;
}
.mt20{
  margin-top: 20px;
}

@media screen and (max-width: 1200px){
  #mainsidebar{
    display:none;
  }
  #content{
    margin-top: 100px;
  }
  #mainContent{
    width:100%;
  }


}

@media screen and (max-width: 990px){
  .prev_step_btn,
  .next_step_btn,
  .contact_step_btn{
    font-size: 12px;

}

button.step{
  display: flex;
flex-direction: column;

}
}
  @media (min-width: 1400px){
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
  max-width: 90% !important;
  }

}

a, a:hover{
  text-decoration: none !important;
}

#footer{
      background : #EAEAEA;
      padding:20px;
      text-align:center;
      font-size: 12px;
      color:#333;
}
#footer a{
  text-align:center;
}

.sidebar_logo_extra_small{
  width: 80px;
height: 40px;
}
.v-btn--icon{
  border:none !important;
}

.footerAbs{
  position:absolute;
  bottom:20px;
  right:20px;
}

.inputFieldName input{
  border: 1px solid #3783C517 !important;
  margin: auto !important;
  width: 100% !important;
  background: #3783C517 !important;
padding: 30px 16px !important;
  font-size: 20px !important;
  border-radius: 50px !important;
  color: #000 !important;
  text-align: left !important;
}


@media screen and (max-width:990px){
  #startuoToAssess{
      padding:20px !important;

  }
  #Completedassessments{

    padding:20px !important;
  }

  .internalAssessment_inner{
    padding:20px !important;
  }
}


.tcenter{
  text-align:center;
}
.thank_you_container{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
  flex-direction: column;
  gap:30px;
}

.thank_you{
  background:#F0F5FA;
  padding:50px;
  padding-bottom:0px !important;
  border-radius:50px;
  max-width:635px;
}
.thank_you .titre_1{
  color:#3783C5;
  font-weight:600;
  font-size:27px;
}
.thank_you .text_1{
  margin-top:30px;
  margin-bottom:20px;
  color:#04246A;
  font-size:18px;
}

</style>

<style media="screen">
.inputFieldPositionSelect .v-field-label--floating,
.inputFieldPositionSelect .v-field__overlay,
.inputFieldPositionSelect .v-field__outline
{
  display:none !important;
}
.inputFieldPositionSelect  .v-field--center-affix .v-label.v-field-label:not(.v-field-label--floating){
  font-size:20px;
  color:#888 !important;
  opacity:1 !important;
}
.inputFieldPositionSelect .v-field{
  background: #3783C517 !important;
  font-size: 20px !important;
  border-radius: 50px !important;

}

.v-theme--myCustomLightTheme{
      --v-disabled-opacity: 1 !important;
  }
  .v-btn--icon{
    border:none !important;
  }

  .inputFieldPositionSelect .v-field__input{
    padding-top: var(--v-field-padding-top) !important;
  }

</style>
